import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de salaire horaire - Calculer le salaire horaire du salaire mensuel";
const DESCRIPTION =
  "Calculatrice de salaire horaire - Calculer le salaire horaire du salaire mensuel. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "salaire horaire salaire horaire salaire mensuel, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/hourly-salary-calculator/";

function HourlySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [hoursPerMonth, setHoursPerMonth] = useState("0");
  const [hourlyRate, setHourlyRate] = useState(null);
  const [error, setError] = useState("");

  const calculateHourlyRate = () => {
    try {
      if (monthlySalary === "0" || hoursPerMonth === "0") {
        setError("Veuillez entrer un salaire mensuel et des heures de travail valides");
        return;
      }
      const hourly = parseFloat(monthlySalary) / parseFloat(hoursPerMonth);
      setHourlyRate(hourly);
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleReset = () => {
    setMonthlySalary("0");
    setHoursPerMonth("0");
    setHourlyRate(null);
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice offre un moyen facile et rapide de convertir votre 
                  salaire mensuel en salaire horaire. Connaître votre taux horaire est 
                  essentiel pour comprendre la valeur réelle de votre temps de travail, 
                  négocier des heures supplémentaires ou évaluer les opportunités de travail 
                  à temps partiel.
                </p>
                <p>
                  Par exemple, si vous gagnez 3000 € par mois et travaillez 160 heures 
                  par mois, votre salaire horaire est d'environ 18,75 €. Cette information 
                  vous aide à prendre des décisions financières éclairées concernant votre 
                  emploi et votre carrière.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center mb-3">
                    <label htmlFor="salary" style={{ marginRight: "10px", minWidth: "180px" }}>Salaire mensuel:</label>
                    <input
                      id="salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                      placeholder="Exemple: 3000"
                      step="0.01"
                      min="0"
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <label htmlFor="hours" style={{ marginRight: "10px", minWidth: "180px" }}>Heures de travail par mois:</label>
                    <input
                      id="hours"
                      type="number"
                      value={hoursPerMonth}
                      onChange={(e) => setHoursPerMonth(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                      placeholder="Exemple: 160"
                      step="0.01"
                      min="0"
                    />
                  </div>
                  <br />
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "16px" }}
                      onClick={calculateHourlyRate}
                    >
                      Calculer
                    </button>
                    <button
                      className="btn btn-secondary"
                      style={{ fontSize: "16px" }}
                      onClick={handleReset}
                    >
                      Réinitialiser
                    </button>
                  </div>
                </div>
                {error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Erreur: {error}</p>
                ) : (
                  hourlyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p style={{ fontSize: "16px" }}>
                        <strong>Salaire horaire: {hourlyRate.toFixed(2)} €/h</strong>
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Qu'est-ce que le salaire horaire ?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Le <strong>salaire horaire</strong> est la rémunération que vous percevez 
                  pour chaque heure de travail. C'est une mesure importante qui vous permet 
                  de comprendre la <strong>valeur réelle de votre temps</strong> et de le 
                  comparer avec d'autres opportunités professionnelles.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  Contrairement au salaire mensuel qui peut sembler stable, le taux horaire 
                  vous aide à évaluer combien vous êtes vraiment payé, surtout si votre nombre 
                  d'heures varie d'un mois à l'autre ou si vous envisagez du travail 
                  supplémentaire.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Pourquoi connaître son salaire horaire?</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Négociation salariale:</strong> Vous pouvez négocier votre salaire à partir d'un taux horaire</li>
                  <li><strong>Heures supplémentaires:</strong> Évaluer le coût réel des heures extras</li>
                  <li><strong>Comparaison d'emplois:</strong> Comparer objectivement différents postes</li>
                  <li><strong>Planification financière:</strong> Mieux planifier vos revenus futurs</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Comment calculer le salaire horaire</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  La <strong>formule pour calculer le salaire horaire</strong> est très simple:
                </p>
                <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                  <strong>Formule:</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    Salaire horaire = Salaire mensuel ÷ Heures de travail par mois
                  </code>
                </div>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Exemple pratique:</h3>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>Données:</strong>
                  <ul style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <li>Salaire mensuel: 3000 €</li>
                    <li>Heures de travail par mois: 160 heures</li>
                  </ul>
                  <strong>Calcul:</strong>
                  <br />
                  3000 ÷ 160 = <strong>18,75 €/heure</strong>
                </div>
                <p style={{ lineHeight: "1.8" }}>
                  Si vous travaillez des heures supplémentaires à 150% (coefficient de 1,5), 
                  votre taux pour les heures extras serait: 18,75 € × 1,5 = <strong>28,13 €/heure</strong>
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Importance de connaître son salaire horaire</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Connaître votre <strong>taux horaire exact</strong> est crucial pour plusieurs raisons:
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>1. Négociation salariale</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Lors d'entretiens d'embauche ou de demandes d'augmentation, vous pouvez 
                  proposer un taux horaire basé sur vos compétences et votre expérience plutôt 
                  que de vous laisser dicter le salaire.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>2. Évaluation du travail supplémentaire</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Avant d'accepter des heures supplémentaires, vous savez exactement combien 
                  vous allez gagner et pouvez décider si cela en vaut la peine par rapport 
                  à votre temps libre.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>3. Comparaison entre emplois</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Deux emplois avec des salaires mensuels différents peuvent avoir le même 
                  taux horaire. Avec votre taux horaire, vous pouvez comparer objectivement 
                  les offres d'emploi.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>4. Travail indépendant</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les travailleurs indépendants doivent toujours connaître leur taux horaire 
                  pour fixer leurs tarifs de manière compétitive et couvrir tous leurs coûts.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Conseils pour les travailleurs horaires</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Voici quelques conseils pratiques pour les personnes payées à l'heure:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Suivi du temps:</strong> Documentez précisément les heures travaillées 
                    pour assurer une rémunération correcte.
                  </li>
                  <li>
                    <strong>Comprendre les coefficients:</strong> Connaître les multiplicateurs 
                    pour les heures supplémentaires, le travail de nuit, etc.
                  </li>
                  <li>
                    <strong>Augmentations régulières:</strong> Demandez régulièrement des 
                    augmentations basées sur votre expérience et vos compétences.
                  </li>
                  <li>
                    <strong>Faire des budgets réalistes:</strong> Si vos heures varient, basez 
                    votre budget sur un nombre d'heures conservateur.
                  </li>
                  <li>
                    <strong>Investir en compétences:</strong> Plus vos compétences sont valuées, 
                    plus vous pouvez demander un taux horaire élevé.
                  </li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Questions fréquemment posées</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Comment calculer les heures de travail par mois?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Généralement, si vous travaillez 8 heures par jour pendant 5 jours par semaine, 
                  cela fait 40 heures par semaine. Sur un mois de 4,3 semaines en moyenne, 
                  cela représente environ 172 heures par mois, ou environ 160 heures si l'on exclut 
                  les jours fériés.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Comment les heures supplémentaires affectent-elles mon salaire horaire?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les heures supplémentaires sont généralement payées à un taux majoré (souvent 
                  25% à 50% de plus). Votre taux horaire de base reste le même, mais les heures 
                  supplémentaires vous paient davantage par heure.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Mon taux horaire change-t-il avec les congés?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Non, votre salaire horaire est un calcul théorique basé sur votre salaire total 
                  et vos heures travaillées. Les congés payés ne changent pas ce calcul, car le 
                  salaire reste le même.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HourlySalaryCalculator;
